import { classNames } from '@progress/kendo-react-common';
import { GridCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import { FC, ReactNode, useMemo } from 'react';

export const useGridCellDisplayValue = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;

  const intl = useInternationalization();
  const value: string = useMemo(() => dataItem?.[field], [dataItem, field]);
  const isNumberFormat =
    props.format?.includes('c') || props.format?.includes('n') || props.format?.includes('p');
  const newValue = isNumberFormat ? Number(value || 0) : value;
  const displayValue: string = useMemo(
    () =>
      newValue !== undefined && newValue !== null
        ? props.format
          ? intl?.format(props.format, newValue)
          : newValue?.toString()
        : '',
    [newValue, props.format, intl]
  );

  return { displayValue: displayValue === 'NaN' ? '$0.00' : displayValue, value };
};

const GridCellBase: FC<
  GridCellProps & {
    children: ReactNode;
    title?: string;
    disableToolTip?: boolean;
    rowSelectionEnabled?: boolean;
    onClick?: VoidFunction;
  }
> = ({
  children,
  isSelected,
  className,
  dataItem,
  field,
  title,
  style,
  disableToolTip = false,
  selectionChange,
  onChange,
  onClick,
  rowSelectionEnabled = false,
}) => {
  let classes = classNames('k-grid-edit-cell', 'k-table-td', {
    'k-selected': isSelected,
  });

  return (
    <td
      className={classes + ' ' + className}
      data-tooltip-id={'global-tooltip'}
      data-tooltip-content={
        disableToolTip ? undefined : title || dataItem?.[field || '']?.toString()
      }
      style={style}
      onClick={() => {
        if (rowSelectionEnabled) {
          selectionChange?.(dataItem);
          onChange?.(dataItem);
        }
        onClick?.();
      }}
    >
      {children}
    </td>
  );
};

export default GridCellBase;
